import { sobrescreverInformacoesAction } from 'app/redux/orcamentoSlice';
import store from 'app/redux/store/store';
import { ControllerBase } from 'controllerBase';
import globalMU from 'globalMU';
import global from 'globalMU'

declare var window:any
declare var orcamentoController:any
declare var TransportadoraOrcamentoController:any
declare var FreteOrcamentoController:any
declare var TipoEntregaOrcamentoController:any

const EntregaOrcamentoController = ControllerBase.extend({
    name: "EntregaOrcamentoController",

    framework: "knockout",

    ajax: function() {

        return {
            url: "/Orcamento/_Entrega",
            type: "get",
            cache: false,
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                tipoOrcamento: this.orcamento.get("TipoOrcamento"), // FNX-5830
                codigofilialVenda: this.orcamento.get("CodigoFilialOrcamento")
            }
        };
    },

    antesBinding: function() {

        this.appendToModel({ name: "habilitar", value: $.proxy(this.habilitar, this) });
        //
        this.appendToModel({ name: "DataPrevisaoEntregaAnterior", value: global.formatDate(this.model.DataPrevisaoEntrega()) }); // FNX-4843
        this.appendToModel({ name: "DataMarcadaEntregaAnterior", value: global.formatDate(this.model.DataMarcadaEntrega()) }); // FNX-4843

        this.appendToModel({
            name: "novo",
            value: (!this.model.DataPrevisaoEntrega || !this.model.DataPrevisaoEntrega()) &&
                (!this.model.DataMarcadaEntrega || !this.model.DataMarcadaEntrega()) &&
                (!this.model.TurnoEntrega || !this.model.TurnoEntrega()) &&
                (!this.model.EntregaPosterior || !this.model.EntregaPosterior())
        });

    },
    events: {
        'click #Entrega_DataPrevisaoEntrega_replicar': "replicarDataPrevistaOrcamento",
        'blur #Entrega_DataPrevisaoEntrega': "dataPrevisaoEntregaAlterada",
        'click #Entrega_DataMarcadaEntrega_replicar': "replicarMarcadaEntregaOrcamento",
        'blur #Entrega_DataMarcadaEntrega': "dataMarcadaEntregaAlterada",
    },

    aposBinding: function () {
        for (var item in this.model.__ko_mapping__.mappedProperties) {
            this.model[item].subscribe(function () {
                orcamentoController.model.DadosAlteradosEntrega["entrega"] = true;

            });
        }
        $('a[data-toggle="tab"]', this.region.$el).on("shown.bs.tab", $.proxy(this.tabSelecionada, this));
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    replicarDataPrevistaOrcamento: function (e) { // FNX-4843
        this.salvar();
        if (this.orcamento.DadosAlterados == true) {
            return false;
        }
        if (e) e.preventDefault();
        var self = this;

        var atualizarEntrega = this.toJS(this.model);

        global.ajax({
            url: "/Orcamento/ReplicarDatas",
            type: "post",
            contentType: "application/json",
            cache: false,
            data: global.toJSONString({
                atualizarEntrega: atualizarEntrega,
                alterarDataPrevista: true,
            }),
            success: function (data) {

                if (!data || data.HasErrors) {
                    return;
                }

                self.tratarBotoesReplicar(); // FNX-4843
                global.showSuccessMessage("Datas alteradas com sucesso!")
            }
        });
        
    },
    
    replicarMarcadaEntregaOrcamento: function (e) { // FNX-4843
        this.salvar();
        if (this.orcamento.DadosAlterados == true) {
            return false;
        }
        if (e) e.preventDefault();
        var self = this;

        var atualizarEntrega = this.toJS(this.model);

        global.ajax({
            url: "/Orcamento/ReplicarDatas",
            type: "post",
            contentType: "application/json",
            cache: false,
            data: global.toJSONString({
                atualizarEntrega: atualizarEntrega,
                alterarDataPrevista: false,
            }),
            success: function (data) {

                if (!data || data.HasErrors) {
                    return;
                }

                self.tratarBotoesReplicar(); // FNX-4843
                global.showSuccessMessage("Datas alteradas com sucesso!")
            }
        });
    },

    dataPrevisaoEntregaAlterada: function () { // FNX-4843
        this.tratarBotoesReplicar();
    },

    dataMarcadaEntregaAlterada: function () { // FNX-4843
        this.tratarBotoesReplicar();
    },

    habilitar: function () {
        if (!this.model.novo() && this.model.permitidoAlterar()) {
            return true;
        } else if (this.model.novo() && this.model.permitidoIncluir()) {
            return true;
        }

        return false;
    },

    tratarBotoesReplicar: function () { // FNX-4843
        var permite = false;
        if (this.orcamento) {
            if (this.orcamento.get("SomenteLeitura")) {
                $("#Entrega_DataPrevisaoEntrega_replicar").remove();
                $("#Entrega_DataMarcadaEntrega_replicar").remove();
                return;
            }
            var itens = this.orcamento.get("ItensOrcamento")
            if (itens && itens !== undefined && itens.length > 0) {
                if (!this.model.novo() && this.model.permitidoAlterar()) {
                    permite = true;
                } else if (this.model.novo() && this.model.permitidoIncluir()) {
                    permite = true;
                }
            }
        }
        if (permite) {
            if (this.model && this.model.DataPrevisaoEntrega && this.model.DataPrevisaoEntrega() !== null && this.model.DataPrevisaoEntrega() !== "") {
                $("#Entrega_DataPrevisaoEntrega_replicar").show();
                if (this.model && this.model.DataPrevisaoEntregaAnterior && this.model.DataPrevisaoEntregaAnterior() !== global.formatDate(this.model.DataPrevisaoEntrega()) ) {
                    //$("#Entrega_DataPrevisaoEntrega_replicar").enable(false);
                }
                else {
                    $("#Entrega_DataPrevisaoEntrega_replicar").enable(true);
                }
            } else {
                $("#Entrega_DataPrevisaoEntrega_replicar").hide();
            }
            if (this.model && this.model.DataMarcadaEntregaAnterior()) {
                $("#Entrega_DataPrevisaoEntrega_replicar").enable(false);
            }

            if (this.model && this.model.DataMarcadaEntrega && this.model.DataMarcadaEntrega() !== null && this.model.DataMarcadaEntrega() !== "") {
                $("#Entrega_DataMarcadaEntrega_replicar").show();
                if (this.model && this.model.DataMarcadaEntregaAnterior && this.model.DataMarcadaEntregaAnterior() !== global.formatDate(this.model.DataMarcadaEntrega()) ) {
                    //$("#Entrega_DataMarcadaEntrega_replicar").enable(false);
                } else {
                    $("#Entrega_DataMarcadaEntrega_replicar").enable(true);
                }
            }
            else {
                $("#Entrega_DataMarcadaEntrega_replicar").hide();
            }
        }
        else {
            $("#Entrega_DataPrevisaoEntrega_replicar").hide();
            $("#Entrega_DataMarcadaEntrega_replicar").hide();
        }
    },
    renderizacaoCompleta: function () {
        this.tratarBotoesReplicar(); // FNX-4843
    },

    antesRenderizacaoCompleta: function() {
        this.atualizarBotoes(); // FNX-4843
    },

    atualizarBotoes: function() {
        this.addActionButton({
                text: "Limpar",
                'class': "icone-excluir separador",
                click: $.proxy(function() {

                        global.clearFormFields({
                            selector: this.formConfig.selector
                        });
                    },
                    this)
            },
            true);
    },

    formConfig: {
        selector: "#form-entrega-orcamento",
        submit: {
            selector: "#salvar-entrega",
            loadingText: "Aguarde...",
            callback: "salvar",
            type: "model",
            modelType: "js"
        },
        rules: {
            'DataPrevisaoEntrega': {
                validateDate: true,
                dateGreaterOrEqualThanActualDate: true
            },
            'DataMarcadaEntrega': {
                validateDate: true,
                dateGreaterOrEqualThanActualDate: true
            }
        },
        messages: {
            'DataPrevisaoEntrega': {
                validateDate: 'O campo "Data Prevista" é inválido.',
                dateGreaterOrEqualThanActualDate: 'O campo "Data Prevista" deve ser maior ou igual a data atual.'
            },
            'DataMarcadaEntrega': {
                validateDate: 'O campo "Data Marcada" é inválido.',
                dateGreaterOrEqualThanActualDate: 'O campo "Data Marcada" deve ser maior ou igual a data atual.'
            }
        },
        ignore: []

    },


    salvar: function() {

        var self = this;

        var atualizarEntrega = this.toJS(this.model);

        global.ajax({
            url: "/Orcamento/AtualizarEntrega",
            type: "post",
            contentType: "application/json",
            cache: false,
            async: false,
            data: global.toJSONString({
                atualizarEntrega: atualizarEntrega
            }),
            success: function(data) {

                if (!data || data.HasErrors) {
                    return;
                }

                self.model.DataPrevisaoEntrega(data.DataPrevisaoEntrega
                    ? global.formatDate(data.DataPrevisaoEntrega)
                    : null);
                self.model.DataMarcadaEntrega(data.DataMarcadaEntrega
                    ? global.formatDate(data.DataMarcadaEntrega)
                    : null);
                self.model.TurnoEntrega(data.TurnoEntrega);
                self.model.EntregaPosterior(data.EntregaPosterior);

                if (self.model.DataPrevisaoEntrega && self.model.DataPrevisaoEntrega()) {
                    self.orcamento.set("DataPrevisaoEntrega", self.model.DataPrevisaoEntrega());
                    store.dispatch(sobrescreverInformacoesAction({DataPrevisaoEntrega: self.model.DataPrevisaoEntrega()}));
                } else {
                    self.orcamento.unset("DataPrevisaoEntrega");
                    store.dispatch(sobrescreverInformacoesAction({DataPrevisaoEntrega: undefined}));
                }

                if (self.model.DataMarcadaEntrega && self.model.DataMarcadaEntrega()) {
                    self.orcamento.set("DataMarcadaEntrega", self.model.DataMarcadaEntrega());
                    store.dispatch(sobrescreverInformacoesAction({DataMarcadaEntrega: self.model.DataMarcadaEntrega()}))
                } else {
                    self.orcamento.unset("DataMarcadaEntrega");
                    store.dispatch(sobrescreverInformacoesAction({DataMarcadaEntrega: undefined}))
                }

                if (self.model.TurnoEntrega && self.model.TurnoEntrega()) {
                    self.orcamento.set("TurnoEntrega", self.model.TurnoEntrega());
                    store.dispatch(sobrescreverInformacoesAction({TurnoEntrega: self.model.TurnoEntrega()}))
                } else {
                    self.orcamento.unset("TurnoEntrega");
                    store.dispatch(sobrescreverInformacoesAction({TurnoEntrega: undefined}))
                    
                }

                self.orcamento.set("EntregaPosterior", self.model.EntregaPosterior());
                store.dispatch(sobrescreverInformacoesAction({EntregaPosterior: self.model.EntregaPosterior()}))

                self.model.DataPrevisaoEntregaAnterior(global.formatDate(self.model.DataPrevisaoEntrega())); // FNX-4843
                self.model.DataMarcadaEntregaAnterior(global.formatDate(self.model.DataMarcadaEntrega())); // FNX-4843

                // store.dispatch(sobrescreverInformacoesAction({
                //     DataPrevisaoEntregaAnterior: global.formatDate(self.model.DataPrevisaoEntrega()),
                //     DataMarcadaEntregaAnterior: global.formatDate(self.model.DataMarcadaEntrega())
                // }))

                if (!data.HasErrors) {
                    global.showSuccessMessage("Dados da entrega atualizados com sucesso.");
                    self.orcamento.DadosAlteradosEntrega["entrega"] = false;
                }
                self.tratarBotoesReplicar(); // FNX-4843
            }
        });
    },

    tabSelecionada: function(e) {

        var name = $(e.target).attr("aria-controls");

        switch (name) {
        case "tab-entrega":
            this.atualizarBotoes();
            this.tratarBotoesReplicar(); // FNX-4843
            break;
        case "tab-transportadora":

            if (this.transportadoraController) {
                this.transportadoraController.atualizarBotoes();
                return;
            }

            this.transportadoraController = this.showView({
                region: {
                    name: "transportadoraRegion",
                    selector: "#tab-transportadora"
                },
                controller: {
                    type: TransportadoraOrcamentoController,
                    args: {
                        orcamento: this.orcamento,
                        readOnly: this.readOnly
                    }
                }
            });

            break;
        case "tab-frete":

            if (this.freteOrcamentoController) {
                this.freteOrcamentoController.atualizarBotoes();
                this.freteOrcamentoController.pesquisar();
                return;
            }

            this.freteOrcamentoController = this.showView({
                region: {
                    name: "freteOrcamentoRegion",
                    selector: "#tab-frete"
                },
                controller: {
                    type: FreteOrcamentoController,
                    args: {
                        orcamento: this.orcamento,
                        readOnly: this.readOnly
                    }
                }
            });


            break;

        case "tab-tipo-entrega":

            if (this.tipoEntregaOrcamentoController) {
                this.tipoEntregaOrcamentoController.atualizarBotoes();
                return;
            }

            this.tipoEntregaOrcamentoController = this.showView({
                region: {
                    name: "tipoEntregaOrcamentoControllerRegion",
                    selector: "#tab-tipo-entrega"
                },
                controller: {
                    type: TipoEntregaOrcamentoController,
                    args: {
                        orcamento: this.orcamento,
                        readOnly: this.readOnly
                    }
                }
            });


            break;

        }

    }

});

window.EntregaOrcamentoController = EntregaOrcamentoController

export {
    EntregaOrcamentoController
}